// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconFilesFileFileUnsupported_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 0H2V30H15.5155C15.1025 29.383 14.7638 28.7121 14.5121 28H4V2H14V0ZM24 10V16.0549C23.6717 16.0186 23.338 16 23 16C22.662 16 22.3283 16.0186 22 16.0549V10H24ZM16 0L24 8H16V0ZM23 30C25.7614 30 28 27.7614 28 25C28 23.9808 27.6951 23.0329 27.1715 22.2424L20.2424 29.1715C21.0329 29.6951 21.9808 30 23 30ZM18.8283 27.7572L25.7572 20.8283C24.9668 20.3048 24.019 20 23 20C20.2386 20 18 22.2386 18 25C18 26.019 18.3048 26.9668 18.8283 27.7572ZM23 32C26.866 32 30 28.866 30 25C30 21.134 26.866 18 23 18C19.134 18 16 21.134 16 25C16 28.866 19.134 32 23 32Z" class="svg-bg"/>
</svg>
`;
const _s80IconSvg = html `<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M52 0 70 18H52V0ZM14 4H48V0H10V80H53.3367C51.8739 78.861 50.5821 77.5126 49.5062 76H14V4ZM66 46.0259C67.3772 46.0973 68.7157 46.3153 70 46.6648V22H66V46.0259Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M80 65C80 73.2843 73.2843 80 65 80C56.7157 80 50 73.2843 50 65C50 56.7157 56.7157 50 65 50C73.2843 50 80 56.7157 80 65ZM76 65C76 71.0751 71.0751 76 65 76C62.685 76 60.537 75.2849 58.7649 74.0634L74.0634 58.7649C75.2849 60.537 76 62.685 76 65ZM55.9365 71.235L71.235 55.9365C69.4629 54.7151 67.315 54 65 54C58.9249 54 54 58.9249 54 65C54 67.315 54.7151 69.4629 55.9365 71.235Z" class="svg-bg"/>
</svg>
`;
/**
 * IconFilesFileFileUnsupported is a generated icon component.
 */
let IconFilesFileFileUnsupported = IconFilesFileFileUnsupported_1 = class IconFilesFileFileUnsupported extends IconBaseElement {
    render() {
        return html `${IconFilesFileFileUnsupported_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconFilesFileFileUnsupported.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s80IconSvg],
    ['s48', _s80IconSvg],
    ['s64', _s80IconSvg],
    ['s72', _s80IconSvg],
    ['s80', _s80IconSvg],
]);
IconFilesFileFileUnsupported = IconFilesFileFileUnsupported_1 = __decorate([
    customElement('zui-icon-files-file-file-unsupported')
], IconFilesFileFileUnsupported);
export { IconFilesFileFileUnsupported };
